<template>
	<div class="main module-dashboard">
		<div class="moduel-dashboard-content">
			<h1 class='dashboard-help-center-heading'>Help Articles</h1>
			<div class="dashboard-help-center">
				<div class="dashboard-help-articles-list">
		        	<div v-for="(item, index) in kbMenu">
			            <div :class="['article-category-link', 'pointer', { 'active-article': kbItemId == item.kb_item_id } ]" @click="getKBItem(item)">{{ item.topic }}</div>
			            <ul>
			                <li :class="['article-link', 'pointer', { 'active-article': kbItemId == subItem.kb_item_id } ]" v-for="(subItem, index) in item.sub_menu" @click="getKBItem(subItem)">{{ subItem.topic }}</li>
			            </ul>
					</div>
				</div>
				<div class="dashboard-article-detail" v-if="kbItem.kb_item_id">
				    <h1>{{ kbItem.topic }}</h1>
				    <div v-html="kbItem.content"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			kbMenu: [],
			kbItem: {},
			kbItemId: '',
			loadingArticle: false,
		}
	},
	created() {
		this.getKBMenu()
	},
	methods: {
		getKBMenu() {
			this.apiCall({ destination: 'get_kb_menu', data: { parent_item_topic: 'Range' } }).then(obj => {
				if (obj.status == 'success') {
					this.kbMenu = obj.kb_menu
					this.getKBItem(this.kbMenu[0])
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getKBItem(item) {
			if (this.loadingArticle || this.kbItemId == item.kb_item_id) { return }
			this.loadingArticle = true
			this.kbItemId = item.kb_item_id
			this.apiCall({ destination: 'get_item_kb_item', data: { kb_item_id: this.kbItemId } }).then(obj => {
				this.loadingArticle = false
				if (obj.status == 'success') {
					this.kbItem = obj.kb_item
				}
			}).catch(err => {
				console.log(err)
			})

		}
	}
}
</script>

<style lang="scss">
</style>
